"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BetSlipSource = void 0;
var BetSlipSource;
(function (BetSlipSource) {
    BetSlipSource[BetSlipSource["Unknown"] = 0] = "Unknown";
    BetSlipSource[BetSlipSource["Web"] = 1] = "Web";
    BetSlipSource[BetSlipSource["Shop"] = 2] = "Shop";
    BetSlipSource[BetSlipSource["Terminal"] = 3] = "Terminal";
    BetSlipSource[BetSlipSource["Mobile"] = 4] = "Mobile";
    BetSlipSource[BetSlipSource["Phone"] = 5] = "Phone";
    BetSlipSource[BetSlipSource["Sms"] = 6] = "Sms";
    BetSlipSource[BetSlipSource["Callcenter"] = 7] = "Callcenter";
    BetSlipSource[BetSlipSource["EasyWeb"] = 8] = "EasyWeb";
    BetSlipSource[BetSlipSource["Woq"] = 9] = "Woq";
    BetSlipSource[BetSlipSource["Comeon"] = 10] = "Comeon";
    BetSlipSource[BetSlipSource["Agent"] = 11] = "Agent";
})(BetSlipSource = exports.BetSlipSource || (exports.BetSlipSource = {}));
